/*
 * Het scoringsmodel van de geurquiz. Drie fasen: filteren, scoren, de set van
 * zes samenstellen.
 *
 * Dit bestand raakt de DOM niet aan en kent de vragen niet als schermen, alleen
 * als antwoorden. Dat is met opzet: zo draaien de acceptatietests er los op, in
 * Node, zonder browser en zonder winkel. Wat je hier verandert is meteen te
 * meten -- en dit is precies het stuk waar je dat wilt kunnen.
 *
 * Alle getallen komen uit quiz-config.json. Staat er in dit bestand een getal,
 * dan is dat een fout.
 */
(function (root, fabriek) {
  if (typeof module === 'object' && module.exports) module.exports = fabriek();
  else root.SentirGeurModel = fabriek();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /* Van intiem naar ruimtevullend; de afstand ertussen is wat telt. */
  var SILLAGE_LADDER = ['Intiem', 'Aanwezig', 'Ruimtevullend'];

  /*
   * Een beoordeling met weinig stemmen zegt weinig. Vijf sterren uit vier
   * reviews hoort niet boven 4,9 uit eenenzestig te gaan, dus trekken we het
   * cijfer naar het gemiddelde toe naarmate er minder stemmen zijn.
   */
  function gewogenOordeel(geur) {
    var cijfer = Number(geur.rating) || 0;
    var aantal = Number(geur.ratingAantal) || 0;
    if (!cijfer || !aantal) return 0;
    var DREMPEL = 10;
    return (cijfer * aantal + 4.5 * DREMPEL) / (aantal + DREMPEL);
  }

  function snij(lijst) {
    return Array.isArray(lijst) ? lijst : [];
  }

  /*
   * De gedragsbonus. De score zegt hoe goed een geur bij de antwoorden past;
   * dit zegt of mensen zo'n aanbeveling ook meenamen. Bij de vorige quiz liepen
   * die twee ver uiteen: de vier meest getoonde geuren belandden in 3,6 tot
   * 4,0% van de gevallen in een mandje, de middenlaag in 7 tot 8%.
   *
   * Bewust een BONUS op de score en geen aparte ronde erna. Zo blijft de match
   * de hoofdmoot -- een paar punten verschuiven wie er wint bij een klein
   * verschil, maar halen nooit een slecht passende geur naar boven.
   *
   * Alles staat in quiz-config.json; op weging 0 doet dit niets.
   */
  function gedragsbonus(geur, config) {
    var d = config.gedrag;
    if (!d) return 0;
    var uit = 0;

    /*
     * Hoe vaak een aanbeveling in het mandje belandde. Op handle óf titel:
     * de eigen meting kent alleen titels, en het dashboard bouwt zijn
     * conversiekaart daaruit -- terwijl de hand-ingevulde kaarten uit de
     * config op handles staan. Allebei geldig, handle wint.
     */
    if (d.weging) {
      var kaart = d.cart_dit || {};
      var w = kaart[geur.handle] !== undefined ? kaart[geur.handle] : kaart[geur.titel];
      if (w !== undefined) uit += (w - d.midden) * d.weging;
    }

    /*
     * En hoe vaak hij daarna weer terugkwam. Minder retouren dan gemiddeld
     * levert punten op, meer kost ze -- vandaar het gemiddelde MIN het eigen
     * percentage en niet andersom.
     *
     * De percentages in de config zijn al naar het gemiddelde getrokken, zodat
     * een parfum met honderd verkopen niet gestraft wordt omdat het er toevallig
     * twee terugkreeg. Dat rekenwerk hoort niet in de browser thuis.
     */
    var r = d.retour;
    if (r && r.weging) {
      var p = (r.per_geur || {})[geur.handle];
      if (p !== undefined) uit += (r.midden - p) * r.weging;
    }

    return uit;
  }

  /* ---------------------------------------------------------- verkenning -- */

  /*
   * De wildcard. De ranglijst is een zichzelf versterkend systeem: wat nooit
   * in een set staat, kan nooit bewijzen dat het verkoopt. Daarom krijgt bij
   * een klein deel van de uitslagen de zesde plek een geur van buiten de
   * vaste kopgroep -- wel passend (boven de matchvloer, door alle filters,
   * binnen de familiegrens), maar buiten de eerste `boven_top` van de lijst.
   *
   * Deterministisch op een zaad (het sessienummer): binnen dezelfde tab ziet
   * de bezoeker bij herladen dezelfde set. Een gedeelde ?r=-link of een ander
   * tabblad krijgt een éigen sessienummer en dus een eigen trekking -- de
   * eerste vijf plekken zijn daar wél identiek, alleen plek zes kan
   * verschillen. Bewust zo gelaten: het alternatief (het zaad in de deelcode
   * meebakken) maakt elke code een pleefout groter voor een randgeval.
   * Het matchpercentage van de wildcard blijft zijn éigen, eerlijke
   * percentage; de kaart doet niet alsof.
   *
   * Alles hieraan staat uit zolang er geen verkenning wordt meegegeven of
   * kans op 0 staat; dan is dit bestand exact het oude model.
   */

  function zaadGetal(tekst) {
    var h = 1779033703 ^ tekst.length;
    for (var i = 0; i < tekst.length; i += 1) {
      h = Math.imul(h ^ tekst.charCodeAt(i), 3432918353);
      h = (h << 13) | (h >>> 19);
    }
    h = Math.imul(h ^ (h >>> 16), 2246822507);
    h = Math.imul(h ^ (h >>> 13), 3266489909);
    return (h ^ (h >>> 16)) >>> 0;
  }

  function maakToeval(zaad) {
    var t = zaadGetal(String(zaad));
    return function () {
      t = (t + 0x6d2b79f5) >>> 0;
      var r = Math.imul(t ^ (t >>> 15), 1 | t);
      r = (r + Math.imul(r ^ (r >>> 7), 61 | r)) ^ r;
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }

  function verken(set, bovenDeVloer, config, instel) {
    if (!instel || !instel.actief || !(instel.kans > 0) || !instel.zaad) return null;

    var d = config.drempels;
    /* Een krappe set nooit verder uithollen; verkennen is luxe. */
    if (set.length < d.set_grootte) return null;

    var toeval = maakToeval(String(instel.zaad) + '|verkenning');
    if (toeval() >= instel.kans) return null;

    /*
     * Geen standaardwaarde hier: dit bestand hoort geen getallen te bevatten.
     * De aanroeper (verkenningInstel in geurquiz.js) levert boven_top; 0 is
     * een geldige keuze en betekent "geen beschermde kopgroep".
     */
    var boven = instel.boven_top >= 0 ? Math.floor(instel.boven_top) : 20;

    var inSet = {};
    var perFamilie = {};
    set.forEach(function (k) {
      inSet[k.geur.handle] = true;
      perFamilie[k.geur.familiePrimair] = (perFamilie[k.geur.familiePrimair] || 0) + 1;
    });

    /* De laatste plek gaat eruit; zijn familie telt dus niet meer mee. */
    var weg = set[set.length - 1];
    perFamilie[weg.geur.familiePrimair] -= 1;

    var kandidaten = bovenDeVloer.slice(boven).filter(function (k) {
      if (inSet[k.geur.handle]) return false;
      if ((perFamilie[k.geur.familiePrimair] || 0) >= d.max_per_familie) return false;
      return true;
    });
    if (!kandidaten.length) return null;

    var keuze = kandidaten[Math.floor(toeval() * kandidaten.length) % kandidaten.length];
    keuze.verkend = true;
    set[set.length - 1] = keuze;
    return keuze.geur.handle;
  }

  function raakt(a, b) {
    var tweede = snij(b);
    return snij(a).some(function (x) {
      return tweede.indexOf(x) > -1;
    });
  }

  /* ------------------------------------------------------ fase 1: filteren -- */

  /*
   * Een dealbreaker in de basis of het hart haalt de geur weg. In de top niet:
   * topnoten zijn binnen het uur vervlogen, en iemand die van patchoeli gruwelt
   * heeft geen last van een vleugje in de opening. Dat wordt aftrek in fase 2.
   */
  /*
   * De noten in quiz-config.json staan er leesbaar in: "Turkish Rose",
   * "Tobacco Leaf", "Salted Caramel". De index bewaart ze genormaliseerd:
   * "turkish rose", "tobacco leaf", "salted caramel" -- kleine letters, geen
   * leestekens. Vergelijken zonder die stap levert nul treffers op, en dat is
   * precies wat er gebeurde: alle 48 schrijfwijzen misten, waardoor vraag 4
   * geen enkele uitslag veranderde.
   *
   * Hier normaliseren en niet in het configbestand: dan blijft dat bestand
   * leesbaar voor wie er een noot bij zet, en kan er geen nieuwe stille misser
   * ontstaan door een hoofdletter.
   */
  function sleutelVan(noot) {
    return String(noot)
      .toLowerCase()
      .replace(/[‘’']/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function dealbreakerRegels(antwoorden, config) {
    return snij(antwoorden.v4)
      .map(function (label) {
        var regel = config.dealbreakers[label];
        if (!regel) return null;
        return {
          label: label,
          noten: snij(regel.noten ? regel.noten : regel).map(sleutelVan),
          hard: Boolean(regel.hard),
        };
      })
      .filter(Boolean);
  }

  /* Alle verboden noten op een hoop; alleen nog gebruikt door de harde filter. */
  function dealbreakerNoten(antwoorden, config) {
    var uit = [];
    dealbreakerRegels(antwoorden, config).forEach(function (regel) {
      regel.noten.forEach(function (n) {
        if (uit.indexOf(n) === -1) uit.push(n);
      });
    });
    return uit;
  }

  function genderBotst(geur, v1) {
    if (v1 === 'hem') return geur.gender === 'Vrouwelijk';
    if (v1 === 'haar') return geur.gender === 'Mannelijk';
    return false;
  }

  function filter(geuren, antwoorden, config, opties) {
    /*
     * Alleen wat als 'hard' is gemarkeerd verdwijnt hier. De rest is aftrek in
     * fase 2. Patchoeli hard wegfilteren haalde 36 van de 115 geuren weg,
     * terwijl het in een notenlijst staan niet betekent dat je het ruikt.
     */
    var hard = dealbreakerRegels(antwoorden, config)
      .filter(function (r) { return r.hard; })
      .reduce(function (op, r) { return op.concat(r.noten); }, []);

    var voorraad = opties && opties.voorraad;

    /*
     * Sommige geuren zíjn hun noot. De leergeuren scoorden hoog bij iedereen
     * die houtachtig + kruidig + warm koos -- profiel klopt, maar wie leer
     * niet aanklikte krijgt een geur aangeraden die om een noot draait waar
     * hij nooit om vroeg, en leer is te polariserend om zo te verrassen.
     * Deze geuren doen alleen mee als een van hun kernnoten echt gekozen is;
     * welke dat zijn staat per handle in vereist_noot in quiz-config.json.
     */
    var vereist = config.vereist_noot || {};
    var gekozen = snij(antwoorden.v3).map(sleutelVan);

    return geuren.filter(function (geur) {
      if (genderBotst(geur, antwoorden.v1)) return false;

      /*
       * Voorraad staat niet in de index -- die veroudert. Wie hem meegeeft
       * krijgt hem toegepast; wie niets meegeeft filtert niet op voorraad.
       */
      if (voorraad && voorraad[geur.handle] === false) return false;

      var eis = vereist[geur.handle];
      if (eis && !raakt(snij(eis).map(sleutelVan), gekozen)) return false;

      if (hard.length && (raakt(hard, geur.notenBasis) || raakt(hard, geur.notenHart))) return false;

      return true;
    });
  }

  /* -------------------------------------------------------- fase 2: scoren -- */

  /*
   * De gelaagde notenweging is de kern van het model. Een geur met vanille in
   * de basis ís een vanillegeur; vanille in de top is een knipoog. Zonder dat
   * verschil krijgt iemand die vanille koos een citrusgeur met een vleugje
   * vanille terug, en dat voelt als een misser.
   */
  function notenScore(geur, gekozen, g) {
    var punten = 0;

    snij(gekozen).forEach(function (noot) {
      if (snij(geur.notenBasis).indexOf(noot) > -1) punten += g.noot_basis;
      else if (snij(geur.notenHart).indexOf(noot) > -1) punten += g.noot_hart;
      else if (snij(geur.notenTop).indexOf(noot) > -1) punten += g.noot_top;
    });

    return Math.min(punten, g.noten_max);
  }

  function familieScore(geur, gekozen, g) {
    if (!snij(gekozen).length) return 0;
    if (raakt(gekozen, geur.bereikPrimair)) return g.familie_primair;
    if (raakt(gekozen, geur.bereikSecundair)) return g.familie_secundair;
    return 0;
  }

  function sillageScore(geur, wens, g) {
    if (!wens || !geur.sillage) return 0;

    var afstand = Math.abs(SILLAGE_LADDER.indexOf(geur.sillage) - SILLAGE_LADDER.indexOf(wens));
    if (afstand === 0) return g.sillage_exact;
    if (afstand === 1) return g.sillage_naast;
    return 0;
  }

  function momentScore(geur, wens, g) {
    var heeftDag = snij(geur.gelegenheid).indexOf('Dag') > -1;
    var heeftAvond = snij(geur.gelegenheid).indexOf('Avond') > -1;

    /*
     * Bij "allebei" mag dit niet meesturen -- de verdeling wordt in fase 3
     * afgedwongen. Alleen een geur zonder enig moment krijgt minder, want daar
     * weten we het simpelweg niet van.
     */
    if (wens === 'Beide') return heeftDag || heeftAvond ? g.moment_match : g.moment_deels;

    if (!heeftDag && !heeftAvond) return g.moment_deels;
    if (wens === 'Dag') return heeftDag ? g.moment_match : 0;
    if (wens === 'Avond') return heeftAvond ? g.moment_match : 0;
    return 0;
  }

  /*
   * Warm of fris is de as die het meest over een geur zegt, en hij moet
   * beslissend zijn. Stond eerst op +10 bij een treffer en 0 bij een misser --
   * een verschil van tien, terwijl een geur aan de verkeerde kant tot negentien
   * punten kon goedmaken op familie, sillage en karakter. Vandaar dat iemand die
   * "fris" antwoordde een warme houtgeur bovenaan kon krijgen.
   *
   * Nu een treffer én een aftrek, samen ruim boven wat er goed te maken valt.
   * Bewust aftrek en geen wegfilteren: kiest iemand aquatisch én warm, dan
   * bestaat die combinatie in dit assortiment niet, en dan is een set met de
   * beste benadering beter dan een lege pagina.
   */
  function warmteScore(geur, wens, g) {
    if (wens === 'Wisselt') return g.warm_fris_wisselt;
    /* Geen oordeel op het product: dan zegt dit veld niets, dus geen straf. */
    if (!geur.warmte) return g.warm_fris_wisselt;
    return geur.warmte === wens ? g.warm_fris : (g.warm_fris_mis || 0);
  }

  /*
   * Herkenbaar of eigenzinnig. Twee antwoorden en geen tussenweg: bij de vorige
   * quiz koos 61% de herkenbare kant en 39% de eigenzinnige, zonder dat er een
   * "maakt niet uit" bestond, en die vraag verplaatste de uitslag flink. Een
   * derde knop erbij zetten zou de meeste mensen de vraag laten ontwijken --
   * dat is precies wat er bij warm/fris gebeurde toen ik daar wél een derde
   * optie verzon.
   *
   * Wie de vraag overslaat krijgt niets. Een misser kost geen punten maar
   * levert ze ook niet op: dit is een voorkeur, geen dealbreaker.
   */
  function karakterScore(geur, wens, g) {
    if (!wens) return 0;
    return geur.karakter === wens ? g.karakter_match : 0;
  }

  function genderScore(geur, v1, g) {
    if (v1 === 'alles') return g.gender_match;
    if (geur.gender === 'Neutraal') return g.gender_neutraal;

    var gewenst = v1 === 'hem' ? 'Mannelijk' : 'Vrouwelijk';
    return geur.gender === gewenst ? g.gender_match : 0;
  }

  /*
   * Per dealbreaker telt alleen de diepste laag, en één keer. Staat roos in het
   * hart én in de basis, dan is dat -30 en niet -50; en drie rozennoten in
   * dezelfde basis zijn nog steeds één keer roos.
   */
  function dealbreakerAftrek(geur, regels, g) {
    var totaal = 0;

    regels.forEach(function (regel) {
      if (regel.hard) return;
      if (raakt(regel.noten, geur.notenBasis)) totaal += g.dealbreaker_basis;
      else if (raakt(regel.noten, geur.notenHart)) totaal += g.dealbreaker_hart;
      else if (raakt(regel.noten, geur.notenTop)) totaal += g.dealbreaker_top;
    });

    return Math.max(totaal, g.dealbreaker_max);
  }

  /*
   * Delen door wat er in dít antwoordpatroon te halen viel, en niet door 100.
   * Iemand die twee noten koos kan de 32 notenpunten nooit halen; zou je toch
   * door het maximum delen, dan krijgt de zuinige invuller structureel lage
   * percentages en concludeert hij dat het assortiment niet bij hem past.
   */
  function maxHaalbaar(antwoorden, config) {
    var g = config.gewichten;
    var gekozenNoten = snij(antwoorden.v3).length;

    return (
      Math.min(gekozenNoten * g.noot_basis, g.noten_max) +
      (snij(antwoorden.v2).length ? g.familie_primair : 0) +
      (antwoorden.v5 ? g.sillage_exact : 0) +
      g.moment_match +
      (antwoorden.v7 === 'Wisselt' ? g.warm_fris_wisselt : g.warm_fris) +
      (antwoorden.v8 ? g.karakter_match : 0) +
      g.gender_match
    );
  }

  function scoor(geur, antwoorden, config, regels) {
    var g = config.gewichten;

    var delen = {
      noten: notenScore(geur, antwoorden.v3, g),
      familie: familieScore(geur, antwoorden.v2, g),
      sillage: sillageScore(geur, antwoorden.v5, g),
      moment: momentScore(geur, antwoorden.v6, g),
      warmte: warmteScore(geur, antwoorden.v7, g),
      karakter: karakterScore(geur, antwoorden.v8, g),
      gender: genderScore(geur, antwoorden.v1, g),
      dealbreaker: dealbreakerAftrek(geur, regels || [], g),
    };

    var totaal = Object.keys(delen).reduce(function (som, k) {
      return som + delen[k];
    }, 0);

    return { delen: delen, score: Math.max(totaal, 0) };
  }

  function naarProcent(score, max, drempels) {
    if (!max) return 0;
    return Math.min(Math.round((score / max) * drempels.match_cap), drempels.match_cap);
  }

  /* ------------------------------------------- fase 3: de set samenstellen -- */

  /*
   * Niet de top zes van de ranglijst. Dan krijgt de klant zes variaties op
   * hetzelfde thema terug en heeft hij zijn keuzestress weer terug -- precies
   * waar hij de quiz voor deed.
   */
  /*
   * De set moet vol. Er zijn na de filters altijd tientallen geuren over -- de
   * set bleef kort door de vloer en de spreidingsregel, niet door gebrek aan
   * kandidaten. En een pagina die "deze zes vormen jouw set" zegt en er vier
   * toont, verkoopt zichzelf tegen.
   *
   * Aanvullen gebeurt in vaste volgorde, zodat wat er als zesde bij komt zo
   * dicht mogelijk bij de rest ligt:
   *
   *   1. boven de vloer, met de spreidingsregel     (de gewone keuze)
   *   2. boven de vloer, spreidingsregel losgelaten (liever twee uit één familie
   *      dan een zwakke match)
   *   3. onder de vloer, hoogste eerst              (het laatste redmiddel)
   */
  function vulAan(set, alles, config, maxPerFamilie) {
    var d = config.drempels;
    if (set.length >= d.set_grootte) return set;

    var erin = {};
    var perFamilie = {};
    set.forEach(function (k) {
      erin[k.geur.handle] = true;
      perFamilie[k.geur.familiePrimair] = (perFamilie[k.geur.familiePrimair] || 0) + 1;
    });

    alles.forEach(function (kandidaat) {
      if (set.length >= d.set_grootte) return;
      if (erin[kandidaat.geur.handle]) return;

      /* Ook bij aanvullen geldt de spreiding -- alleen ruimer dan normaal. */
      var familie = kandidaat.geur.familiePrimair;
      if ((perFamilie[familie] || 0) >= maxPerFamilie) return;

      erin[kandidaat.geur.handle] = true;
      perFamilie[familie] = (perFamilie[familie] || 0) + 1;
      set.push(Object.assign({}, kandidaat, { slot: set.length + 1, aangevuld: true }));
    });

    return set;
  }

  function stelSetSamen(gerangschikt, antwoorden, config) {
    var d = config.drempels;
    var s = config.straffen;

    var over = gerangschikt.slice();
    var set = [];
    var perFamilie = {};
    var dag = 0;
    var avond = 0;

    /* Bij "allebei ongeveer evenveel" drie voor overdag en drie voor 's avonds. */
    /*
     * De dag/avond-verdeling. Stond altijd aan bij "allebei ongeveer evenveel",
     * en zorgde dat er hoogstens drie puur-dag en drie puur-avond in de set
     * kwamen. Bedoeld als spreiding, maar het duwt een geur die negende staat
     * boven een die vijfde staat -- en dat is precies wat we niet willen.
     * Staat nu uit; terugzetten is drempels.dag_avond_verdelen op true.
     */
    var verdeel = d.dag_avond_verdelen === true && antwoorden.v6 === 'Beide';
    var helft = Math.floor(d.set_grootte / 2);

    function magErbij(kandidaat) {
      var familie = kandidaat.geur.familiePrimair;
      if ((perFamilie[familie] || 0) >= d.max_per_familie) return false;

      if (verdeel) {
        var isDag = snij(kandidaat.geur.gelegenheid).indexOf('Dag') > -1;
        var isAvond = snij(kandidaat.geur.gelegenheid).indexOf('Avond') > -1;
        if (isDag && !isAvond && dag >= helft) return false;
        if (isAvond && !isDag && avond >= helft) return false;
      }

      return true;
    }

    function neem(kandidaat, slot) {
      var familie = kandidaat.geur.familiePrimair;
      perFamilie[familie] = (perFamilie[familie] || 0) + 1;

      if (snij(kandidaat.geur.gelegenheid).indexOf('Dag') > -1) dag += 1;
      if (snij(kandidaat.geur.gelegenheid).indexOf('Avond') > -1) avond += 1;

      set.push(Object.assign({}, kandidaat, { slot: slot }));
      over = over.filter(function (k) {
        return k.geur.handle !== kandidaat.geur.handle;
      });
    }

    /*
     * Slot 1 is de topmatch: hoogste score, verder geen kunstjes. Wel al met de
     * populariteitsrem erin verwerkt -- die zit in de score, niet hier.
     */
    if (over.length) neem(over[0], 1);

    /*
     * Slots 2 tot en met 5. Na elke keuze verliest elke overgebleven geur
     * punten als zijn familie al in de set zit, waarna de ranglijst opnieuw
     * wordt bepaald. Zo staat er niet drie keer hetzelfde.
     */
    while (set.length < d.set_grootte - 1 && over.length) {
      var gestraft = over
        .map(function (k) {
          var straf = perFamilie[k.geur.familiePrimair] ? s.familie_herhaling : 0;
          return Object.assign({}, k, { gewogen: k.score + (k.bonus || 0) - straf });
        })
        .filter(magErbij)
        .sort(function (a, b) {
          if (b.gewogen !== a.gewogen) return b.gewogen - a.gewogen;
          return gewogenOordeel(b.geur) - gewogenOordeel(a.geur);
        });

      if (!gestraft.length) break;
      neem(gestraft[0], set.length + 1);
    }

    /*
     * Slot 6 is de wildcard: de hoogst scorende geur uit een familie die nog
     * niet in de set zit. Dat is het slot dat iemand iets laat ontdekken wat
     * hij zelf niet had aangeklikt. Haalt hij de vloer niet, dan vervalt hij --
     * liever vijf goede dan zes waarvan er één zichtbaar niet klopt.
     */
    if (set.length < d.set_grootte && d.wildcard !== false) {
      var vreemd = over
        .filter(function (k) {
          return !perFamilie[k.geur.familiePrimair] && magErbij(k);
        })
        .sort(function (a, b) {
          var sa = a.score + (a.bonus || 0);
          var sb = b.score + (b.bonus || 0);
          if (sb !== sa) return sb - sa;
          return gewogenOordeel(b.geur) - gewogenOordeel(a.geur);
        });

      if (vreemd.length) {
        neem(vreemd[0], d.set_grootte);
        set[set.length - 1].wildcard = true;
      }
    }

    /*
     * Geen wildcard gevonden of hem uitgezet: dan gaat het laatste slot alsnog
     * naar de hoogste die over is. Anders levert de quiz vijf geuren terwijl er
     * een zesde klaarstaat die prima past.
     */
    if (set.length < d.set_grootte) {
      var rest = over.filter(magErbij);
      if (rest.length) neem(rest[0], d.set_grootte);
    }

    return set;
  }

  /* --------------------------------------------------------------- redenen -- */

  /*
   * Het model levert de FEITEN waarom een geur past, niet de zin. De zin wordt
   * in geurquiz.js opgebouwd uit teksten die in de theme editor staan -- anders
   * zit er copy in een rekenbestand, en dan is de taal van de winkel niet meer
   * te veranderen zonder aan het model te komen.
   */
  function redenen(kandidaat, antwoorden, config) {
    var geur = kandidaat.geur;
    var g = config.gewichten;

    var geraakt = snij(antwoorden.v3).filter(function (n) {
      return (
        snij(geur.notenBasis).indexOf(n) > -1 ||
        snij(geur.notenHart).indexOf(n) > -1
      );
    });

    return {
      noten: geraakt.slice(0, 2),
      familie: kandidaat.delen.familie >= g.familie_primair ? geur.familiePrimair : null,
      sillage: kandidaat.delen.sillage === g.sillage_exact ? antwoorden.v5 : null,
      moment: kandidaat.delen.moment === g.moment_match ? antwoorden.v6 : null,
    };
  }

  /* -------------------------------------------------------------- de motor -- */

  function adviseer(invoer) {
    var geuren = snij(invoer.geuren);
    var config = invoer.config;
    var antwoorden = invoer.antwoorden || {};
    var d = config.drempels;

    var regels = dealbreakerRegels(antwoorden, config);
    var kandidaten = filter(geuren, antwoorden, config, invoer);
    var max = maxHaalbaar(antwoorden, config);

    var gerangschikt = kandidaten
      .map(function (geur) {
        var uitslag = scoor(geur, antwoorden, config, regels);

        /*
         * De populariteitsrem. Eén op de zes kreeg dezelfde geur als nummer
         * één; die blijft winnen wanneer hij écht de beste match is, maar niet
         * meer op de automatische piloot.
         */
        var populair = (geur.slot1Aandeel || 0) > config.straffen.populariteit_drempel;
        var score = uitslag.score - (populair ? config.straffen.populariteit : 0);

        return {
          geur: geur,
          score: Math.max(score, 0),
          delen: uitslag.delen,
          geremd: populair,
          /*
           * De bonus staat NAAST de score en niet erin: het matchpercentage dat
           * de klant ziet hoort te gaan over hoe goed de geur bij zijn antwoorden
           * past, niet over hoe goed hij verkoopt.
           *
           * De handmatige rem telt hier ook mee, om dezelfde reden: dat is een
           * winkeliersbesluit over een specifieke geur, geen oordeel over hoe
           * goed hij bij de antwoorden past. Hij zakt op de ranglijst en komt
           * dus zelden in de set, maar zijn matchpercentage blijft eerlijk.
           */
          bonus: gedragsbonus(geur, config) -
            ((config.straffen.rem_per_geur || {})[geur.handle] || 0),
          match: naarProcent(Math.max(score, 0), max, d),
        };
      })
      /*
       * Bij gelijke score besliste eerst de handle -- dus het alfabet, wat
       * neerkomt op willekeur. En gelijkspel is hier geen randgeval: laat
       * iemand vraag 3 leeg, dan valt de enige onderscheidende factor binnen
       * een familie weg en scoren tien geuren precies hetzelfde.
       *
       * Dit verandert niets aan wie er wint op match -- alleen aan wie er wint
       * als de match exact gelijk is. Dan liever de geur die klanten beter
       * beoordelen dan de geur die toevallig vooraan in het alfabet staat.
       * Het aantal beoordelingen telt mee, zodat één vijfsterrenreview niet
       * boven vijftig van 4,8 gaat.
       */
      .sort(function (a, b) {
        /* (bonus || 0): een kapotte kaart uit een patch mag nooit als NaN de
         * vergelijking verlammen -- dan blijft een geur match-onafhankelijk
         * op zijn collectieplek hangen. */
        var sa = a.score + (a.bonus || 0);
        var sb = b.score + (b.bonus || 0);
        if (sb !== sa) return sb - sa;
        var ga = gewogenOordeel(a.geur);
        var gb = gewogenOordeel(b.geur);
        if (gb !== ga) return gb - ga;
        return a.geur.handle.localeCompare(b.geur.handle);
      });

    var bovenDeVloer = gerangschikt.filter(function (k) {
      return k.match >= d.match_vloer;
    });

    var set = stelSetSamen(bovenDeVloer, antwoorden, config);

    /*
     * Eerst nog eens proberen met de spreidingsregel losgelaten, en pas daarna
     * onder de vloer duiken.
     */
    if (set.length < d.set_grootte && d.altijd_vol) {
      /*
       * De spreidingsregel stapsgewijs loslaten, niet in één keer. Meteen naar
       * "onbeperkt" leverde sets op waarin alle zes uit dezelfde familie kwamen,
       * en dat is precies de keuzestress die deze pagina wegneemt. Eerst drie
       * per familie, dan vier, en pas als het dan nog niet lukt de rest.
       */
      var ruimte;

      /* Eerst boven de vloer, met stapsgewijs meer ruimte per familie. */
      for (ruimte = d.max_per_familie + 1; ruimte <= d.max_per_familie_ruim; ruimte += 1) {
        if (set.length >= d.set_grootte) break;
        set = vulAan(set, bovenDeVloer, config, ruimte);
      }

      /* Dan pas onder de vloer, en ook daar met de ruime grens. */
      if (set.length < d.set_grootte) {
        set = vulAan(set, gerangschikt, config, d.max_per_familie_ruim);
      }

      /*
       * En als het dan nog niet lukt, alles. Dat gebeurt alleen als de hele
       * collectie in één familie valt na de filters; liever zes uit één familie
       * dan een pagina die zichzelf tegenspreekt.
       */
      set = vulAan(set, gerangschikt, config, d.set_grootte);
    }

    /*
     * De wildcard komt ná de hele samenstelling, zodat de eerste vijf plekken
     * altijd de gewone uitkomst zijn en alleen plek zes ooit verkent.
     */
    var verkend = verken(set, bovenDeVloer, config, invoer.verkenning);

    set.forEach(function (k) {
      k.redenen = redenen(k, antwoorden, config);
    });

    return {
      set: set,
      /* De handle van de wildcard, of null; de meting wil weten wát verkend is. */
      verkend: verkend,
      /*
       * De volledige ranglijst, niet alleen de zes. De uitslagpagina laat je per
       * kaart ruilen naar de eerstvolgende die past, en die moet ergens vandaan
       * komen. Bewust gerangschikt en niet het 'over'-restje uit stelSetSamen:
       * na de vulAan-stappen klopt dat restje niet meer, deze lijst altijd.
       *
       * Alles zit erin, ook wat onder de matchvloer valt -- wie zes keer ruilt
       * hoort niet met een lege knop te eindigen. De uitslagpagina snijdt zelf
       * af waar hij wil.
       */
      gerangschikt: gerangschikt,
      kandidaten: kandidaten.length,
      bovenDeVloer: bovenDeVloer.length,
      maxHaalbaar: max,
      /* Signaal uit §4.1: te weinig over betekent een te ruime dealbreaker. */
      lowCandidatePool: kandidaten.length < d.min_kandidaten_signaal,
      /*
       * Minder dan zes kan nu alleen nog als er echt te weinig geuren zijn --
       * met een genderkeuze en drie dealbreakers blijven er in de praktijk
       * altijd tientallen over.
       */
      onvolledig: set.length < d.set_grootte,
      /* Hoeveel er zijn aangevuld buiten de gewone keuze om. */
      aangevuld: set.filter(function (k) { return k.aangevuld; }).length,
    };
  }

  return {
    adviseer: adviseer,
    filter: filter,
    scoor: scoor,
    maxHaalbaar: maxHaalbaar,
    naarProcent: naarProcent,
    redenen: redenen,
    dealbreakerNoten: dealbreakerNoten,
    dealbreakerRegels: dealbreakerRegels,
    SILLAGE_LADDER: SILLAGE_LADDER,
  };
});
